import { render, staticRenderFns } from "./paradetail.vue?vue&type=template&id=4764364c&scoped=true&"
import script from "./paradetail.vue?vue&type=script&lang=js&"
export * from "./paradetail.vue?vue&type=script&lang=js&"
import style0 from "./paradetail.vue?vue&type=style&index=0&id=4764364c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4764364c",
  null
  
)

export default component.exports